var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarprofileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12778 2.22222C3.12778 1.72568 3.32503 1.24947 3.67614 0.898361C4.02725 0.547251 4.50346 0.35 5 0.35C5.49654 0.35 5.97275 0.547251 6.32386 0.898361C6.67497 1.24947 6.87222 1.72568 6.87222 2.22222C6.87222 2.71877 6.67497 3.19497 6.32386 3.54608C5.97275 3.89719 5.49654 4.09444 5 4.09444C4.50346 4.09444 4.02725 3.89719 3.67614 3.54608C3.32503 3.19497 3.12778 2.71877 3.12778 2.22222ZM1.06108 6.61664C1.51638 6.16134 2.13389 5.90556 2.77778 5.90556H7.22222C7.86611 5.90556 8.48362 6.16134 8.93892 6.61664C9.39422 7.07193 9.65 7.68945 9.65 8.33333C9.65 8.68254 9.51128 9.01744 9.26436 9.26436C9.01744 9.51128 8.68254 9.65 8.33333 9.65H1.66667C1.31746 9.65 0.982565 9.51128 0.735643 9.26436C0.48872 9.01744 0.35 8.68254 0.35 8.33333C0.35 7.68945 0.605783 7.07193 1.06108 6.61664Z",
    stroke: "#791377",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarprofileicon);
export default __webpack_public_path__ + "static/media/avatarprofileicon.ac6e356bfe9caf5d9969466fd66c01e7.svg";
export { ForwardRef as ReactComponent };